export const HOME_CARD_STYLE_OPTIONS = [
  { value: 'DEFAULT', label: 'Normal' },
  { value: 'UPCOMING', label: 'Proximamente' },
  { value: 'LAST_CHANCE', label: 'Ultima oportunidad' },
  { value: 'PETITION', label: 'Peticion' },
];

export const HOME_SECTION_OPTIONS = [
  { value: 'MERCH', label: 'Merch Disponible' },
  { value: 'UPCOMING', label: 'Proximamente' },
  { value: 'LAST_CHANCE', label: 'Ultima oportunidad' },
];

export function getHomeCardStyle(product) {
  if (product?.homeCardStyle) return product.homeCardStyle;
  if (product?.isPetition) return 'PETITION';
  if (product?.isUpcoming) return 'UPCOMING';
  if (product?.isLastChance) return 'LAST_CHANCE';
  return 'DEFAULT';
}

export function hasHomeSection(product, section) {
  if (Array.isArray(product?.homeSections) && product.homeSections.includes(section)) {
    return true;
  }

  if (section === 'MERCH') return product?.featured === true;
  if (section === 'UPCOMING') return product?.isUpcoming === true;
  if (section === 'LAST_CHANCE') return product?.isLastChance === true;
  return false;
}
